export enum LoteSituacao {
  DISPONIVEL = 'DISPONIVEL',
  DESMEMBRAMENTO = 'DESMEMBRAMENTO',
  REMEMBRAMENTO = 'REMEMBRAMENTO',
  INDISPONIVEL = 'INDISPONIVEL',
  CADASTRO = 'CADASTRO',
  CADASTRO_MULTIPLO = 'CADASTRO_MULTIPLO'
}
